import {RouteSectionProps, useNavigate} from "@solidjs/router";
import {useMember} from "~/context/MemberContext";
import {createEffect} from "solid-js";

export default function AuthLayout(props: RouteSectionProps) {

    const member = useMember()
    const navigate = useNavigate()

    createEffect(() => {
        if (member() != null && member() != undefined) {
            navigate("/account", {replace: true})
        }
    })

    return props.children
}